module.exports = __webpack_public_path__ + "img/google-docs.9b7c41b9.jpg";